<template>
  <m-input-select
    :label="label"
    :help-danger="helpDanger"
    :loading="bridgesMeta.loading"
    :options="bridges"
    :value="value"
    @input="handleBridgeSelect"
  />
</template>

<script>
  import { MInputSelect } from 'codefabrik-gui-vue'
  import { bridgeService } from '@/services'
  import { useQuery } from 'codefabrik-gui-vue/src/apollo'

  export default {
    name: 'BridgeSelect',
    components: { MInputSelect },
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: null
      },
      helpDanger: {
        type: String,
        default: null
      },
    },
    mixins: [
      useQuery({
        name: 'bridges',
        serviceFn: bridgeService.getBridges,
        mappingFunctions: {
          bridges: [(bridgeData) => bridgeData.bridge.map(bridge => {
            return {
              value: bridge.id,
              label: bridge.name
            }
          }), () => []],
        },
      })
    ],
    methods: {
      handleBridgeSelect (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
</script>

<style scoped>

</style>
